import { memo, FC, SVGProps } from "react"

export const ArrowUpIcon: FC<SVGProps<SVGSVGElement>> = memo((props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth="0.857143"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M5.99999 9.36721L5.99999 2.63286" />
    <path d="M2.63281 6.00003L5.99999 2.63286L9.36716 6.00003" />
  </svg>
))
export default ArrowUpIcon
